<script>
import { createSafeJSON } from '../../common/functions/safe-json';
import { useCustomTemplate } from "../../common/mixins/custom-templates";
import defaultTemplate from "./packages.template.html";
import modals from "../../components/modals";
import PackageList from "./components/package-list.vue";
import CategoryButtons from "./components/category-buttons.vue";
import PosButtons from "./components/pos-buttons.vue";
import Sections from "./components/sections.vue";

const safeJSON = createSafeJSON('packages')

const SEPARATION_TYPES = {
  NONE: "none",
  SECTION: "section",
  BUTTON: "button",
};

const SHOW_FLOATING_CART = {
  NEVER: "never",
  ALWAYS: "always",
};

function createFloatingCart() {
  let el = window.document.querySelector("ae-floating-cart");

  if (el) {
    return;
  }

  el = window.document.createElement("ae-floating-cart");

  el.addEventListener("toCheckout", () => {
    modals.showCheckoutModal();
  });

  window.document.body.appendChild(el);
}

function getCategories(slugs) {
  return new Promise((resolve) => {
    const categories = [];

    const paginator = window.AngularEcommerce.ws.categories.getAll({
      params: {
        slug_list: slugs,
      },
    });

    paginator.getAllPages((res) => {
      categories.push(...res.data.results);

      if (!paginator.hasNextPage()) {
        resolve(categories);
      }
    });
  });
}

function getPOS() {
  return new Promise((resolve) => {
    const results = [];

    const paginator = window.AngularEcommerce.ws.pointsOfSale.getAll({
      params: {
        is_online: true,
      },
    });

    paginator.getAllPages(({ data }) => {
      results.push(...data.results);

      if (!paginator.hasNextPage()) {
        resolve(results);
      }
    });
  });
}

export default {
  mixins: [useCustomTemplate],

  props: {
    config: Object,
  },

  data() {
    return {
      canRender: false,
      categories: [],
      posList: [],

      templateGroup: "packages",
      templateName: "packagesWidget",
    };
  },

  created() {
    if (this.config.showFloatingCart === SHOW_FLOATING_CART.ALWAYS) {
      createFloatingCart();
    }

    if (this.useSelector && this.config.usePOSAsFilter) {
      getPOS().then((posList) => {
        this.posList = posList;
        this.canRender = true;
      });
    } else if (this.useSections || this.useSelector) {
      getCategories(this.categorySlugList).then((categories) => {
        this.categories = categories;
        this.canRender = true;
      });
    } else {
      this.canRender = true;
    }
  },

  computed: {
    packageConfig() {
      const config = {};

      config.useAddToCartButton = this.config.useAddToCartButton;
      config.useBuyButton = this.config.useBuyButton;
      config.showUnlimitedExplanation = this.config.showUnlimitedExplanation;

      if (this.config.addToCartButtonText) {
        config.addToCartButtonText = this.config.addToCartButtonText;
      }

      if (this.config.removeFromCartButtonText) {
        config.removeFromCartButtonText = this.config.removeFromCartButtonText;
      }

      if (this.config.buyButtonText) {
        config.buyButtonText = this.config.buyButtonText;
      }

      return config;
    },
    useSections() {
      return this.config.separationMode === SEPARATION_TYPES.SECTION;
    },
    useSelector() {
      return this.config.separationMode === SEPARATION_TYPES.BUTTON;
    },
    categorySlugList() {
      return this.config.categorySlugList
        .map((item) => item.value)
        .map((value) => value.trim())
        .join();
    },

    commonProps() {
      console.log(this.config)
      const props = {
        useDefaultGridCols: this.config.useDefaultGridCols === true,
        show_in_carroussel_mobile: this.config.show_in_carroussel_mobile === true,
        show_in_carroussel_desktop: this.config.show_in_carroussel_desktop === true,
        use_location_unit_selector: this.config.use_location_unit_selector === true,
        location_unit_selector_params: safeJSON(this.config.location_unit_selector_params, 'location unit selector params invalid!'),
        use_multi_widgets: this.config.use_multi_widgets === true,
        multi_widgets_params: safeJSON(this.config.multi_widgets_params, 'multi widgets params invalid!'),
        paramsFilterRequestPOS: this.config.paramsFilterRequestPOS,
        titleWidget: this.config.titleWidget,
        useCustomTemplate: this.config.useCustomTemplate === true,
        params: safeJSON(this.config.packageParams, 'packageParams is invalid!'),
        config: this.packageConfig,
        disableGetPackagesOnRender: this.config.disableGetPackagesOnRender === true,
        bonusStripColor: this.config.bonusStripColor,
        showinstallmentsLabel: this.config.showinstallmentsLabel === true,
        showIconsWithInformation: this.config.showIconsWithInformation === true
      };


      if (this.config.useCustomTemplate) {
        props.templateName = this.templateName;
      }
      return props;
    },
  },

  render(h) {
    if (!this.canRender) {
      return;
    }
    
    if (this.useSelector) {
      if (this.config.usePOSAsFilter) {
        return h(PosButtons, {
          props: {
            posList: this.posList,
            ...this.commonProps,
          },
        });
      } else {
        return h(CategoryButtons, {
          props: {
            categories: this.categories,
            ...this.commonProps,
          },
        });
      }
    }

    if (this.useSections) {
      return h(Sections, {
        props: {
          categories: this.categories,
          ...this.commonProps,
        },
      });
    }

    return h(PackageList, {
      props: this.commonProps,
    });
  },
};
</script>